import type { ThemeWithoutTokens } from '../theme.types';

export const textTokens = (theme: ThemeWithoutTokens) =>
  ({
    // common
    textTextColor: theme.colors.body.text,
    textBackgroundColor: theme.colors.body.background,
    textLetterSpacing: theme.typography.letterSpacing.m,
    textFontFamily: theme.typography.fontFamily.regular,

    // body
    textBodyFontWeight: theme.typography.fontWeight.bold,
    textBodyFontSize: theme.typography.fontSize.s,
    textBodyLineHeight: theme.typography.lineHeight.m,

    // body-light
    textBodyLightFontWeight: theme.typography.fontWeight.semibold,
    textBodyLightFontSize: theme.typography.fontSize.s,
    textBodyLightLineHeight: theme.typography.lineHeight.m,

    // body-lighter
    textBodyLighterFontWeight: theme.typography.fontWeight.normal,
    textBodyLighterFontSize: theme.typography.fontSize.s,
    textBodyLighterLineHeight: theme.typography.lineHeight.m,

    // caption
    textCaptionFontWeight: theme.typography.fontWeight.semibold,
    textCaptionFontSize: theme.typography.fontSize.xs,
    textCaptionLineHeight: theme.typography.lineHeight.xs,
  }) as const;
